enum Features {
  psrOptIn = "psrOptIn",
}

export default Features;
